import { Navigate, createFileRoute } from "@tanstack/react-router";
import { InboxWorkspace } from "../components/admin/inbox-workspace";
import { useAuth } from "../stores/auth";

export const Route = createFileRoute("/admin/inbox")({ component: AdminInboxPage });

function AdminInboxPage() {
  const user = useAuth((state) => state.user);
  if (!user) return null;
  if (user.role !== "global_admin") return <Navigate to="/admin/users" replace />;
  return <InboxWorkspace />;
}
